var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconTag = function SvgIconTag(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15.894,
    height: 14.208,
    viewBox: "0 0 15.894 14.208",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M310.521,1899.876a1.342,1.342,0,0,1-1.113-.588l-4.037-5.959a1.339,1.339,0,0,1,.359-1.865l8.2-5.56a1.367,1.367,0,0,1,1.007-.215l5.013.963a1.345,1.345,0,0,1,1.062,1.567l-.966,5.013a1.339,1.339,0,0,1-.574.854l-8.2,5.56a1.328,1.328,0,0,1-.751.229Zm4.18-13.182a.341.341,0,0,0-.195.061l-8.2,5.557a.314.314,0,0,0-.133.2.3.3,0,0,0,.048.235l4.037,5.963a.341.341,0,0,0,.444.085l8.2-5.56a.321.321,0,0,0,.143-.2l.963-5.01a.314.314,0,0,0-.249-.369l-5.01-.963Zm2.175,4.44a1.453,1.453,0,0,1-.239-.021,1.366,1.366,0,0,1-1-.758h0a1.335,1.335,0,0,1,.3-1.567,1.366,1.366,0,0,1,2.148.416,1.339,1.339,0,0,1-.3,1.564A1.288,1.288,0,0,1,316.877,1891.133Zm-.017-1.68a.342.342,0,0,0-.229.092.318.318,0,0,0-.072.362h0a.341.341,0,0,0,.253.2.316.316,0,0,0,.266-.082.321.321,0,0,0,.085-.376.342.342,0,0,0-.242-.188Z",
    transform: "translate(-305.139 -1885.668)",
    fill: "#e2e2e2"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconTag, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon_tag.ebfe6724.svg";
export { ForwardRef as ReactComponent };